import _implicitStylesheets from "./contentTitle.css";
import _implicitScopedStylesheets from "./contentTitle.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="isloading${0}"${2}></div>`;
const stc0 = {
  key: 3
};
const stc1 = [];
const stc2 = {
  key: 5
};
const stc3 = {
  key: 7
};
const stc4 = {
  key: 9
};
const stc5 = {
  key: 11
};
const stc6 = {
  key: 13
};
const stc7 = {
  key: 15
};
const stc8 = {
  key: 17
};
const stc9 = {
  "heading": true
};
const stc10 = {
  key: 19
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {st: api_static_fragment, ncls: api_normalize_class_name, d: api_dynamic_text, t: api_text, s: api_slot, h: api_element} = $api;
  return [$cmp.isLoading ? api_static_fragment($fragment1, 1) : null, !$cmp.isLoading ? $cmp.isLevel1 ? api_element("h1", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-1"
    },
    key: 2
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc0, stc1, $slotset)]) : null : null, !$cmp.isLoading ? $cmp.isLevel2 ? api_element("h2", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-6"
    },
    key: 4
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc2, stc1, $slotset)]) : null : null, !$cmp.isLoading ? $cmp.isLevel3 ? api_element("h3", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-3"
    },
    key: 6
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc3, stc1, $slotset)]) : null : null, !$cmp.isLoading ? $cmp.isLevel4 ? api_element("h4", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-4"
    },
    key: 8
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc4, stc1, $slotset)]) : null : null, !$cmp.isLoading ? $cmp.isLevel5 ? api_element("h5", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-5"
    },
    key: 10
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc5, stc1, $slotset)]) : null : null, !$cmp.isLoading ? $cmp.isLevel6 ? api_element("h6", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-6"
    },
    key: 12
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc6, stc1, $slotset)]) : null : null, !$cmp.isLoading ? $cmp.isLevel7 ? api_element("h6", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-7"
    },
    key: 14
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc7, stc1, $slotset)]) : null : null, !$cmp.isLoading ? $cmp.isLevel8 ? api_element("h6", {
    className: api_normalize_class_name($cmp.titleClass),
    attrs: {
      "util-style": $cmp.style,
      "type-style": "display-8"
    },
    key: 16
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc8, stc1, $slotset)]) : null : null, !$cmp.isLoading ? !$cmp.isHeading ? api_element("div", {
    classMap: stc9,
    attrs: {
      "util-style": $cmp.style
    },
    key: 18
  }, [api_text(api_dynamic_text($cmp.title)), api_slot("", stc10, stc1, $slotset)]) : null : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-442t5q5fa90";
tmpl.legacyStylesheetToken = "undefined-_contentTitle";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
